<script setup>
import { ref, computed } from 'vue'
import api from '../api/http'

const step = ref(1)
const totalSteps = 4

const firstName = ref('')
const lastName = ref('')
const email = ref('')
const phone = ref('')
const extra = ref({ company: '', notes: '' })
const file = ref(null)

const errors = ref({})
const submitting = ref(false)

const canNext1 = computed(() => firstName.value.trim() && lastName.value.trim())

function handleFile(e) { file.value = e.target.files?.[0] || null }

async function submitForm() {
  errors.value = {}
  try {
    submitting.value = true
    const fd = new FormData()
    fd.append('firstName', firstName.value)
    fd.append('lastName', lastName.value)
    fd.append('email', email.value)
    fd.append('phone', phone.value)
    fd.append('extra', JSON.stringify(extra.value))
    if (file.value) fd.append('attachment', file.value)
    await api.post('/forms', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
    window.location.href = '/success'
  } catch (e) {
    errors.value = e.response?.data?.details?.fieldErrors || { _err: ['ส่งไม่สำเร็จ'] }
  } finally { submitting.value = false }
}
</script>

<template>
  <div class="card max-w-2xl mx-auto space-y-4">
    <h1 class="text-xl font-semibold">กรอกแบบฟอร์ม (Step {{ step }}/{{ totalSteps }})</h1>
    <div v-if="step===1" class="space-y-3">
      <input class="input" v-model="firstName" placeholder="ชื่อ (First name)" />
      <input class="input" v-model="lastName" placeholder="นามสกุล (Last name)" />
      <div class="flex gap-2">
        <button class="btn-primary" :disabled="!canNext1" @click="step=2">ถัดไป</button>
      </div>
    </div>
    <div v-else-if="step===2" class="space-y-3">
      <input class="input" v-model="email" placeholder="อีเมล" />
      <input class="input" v-model="phone" placeholder="เบอร์โทร" />
      <div class="flex gap-2">
        <button class="btn-outline" @click="step=1">ย้อนกลับ</button>
        <button class="btn-primary" @click="step=3">ถัดไป</button>
      </div>
    </div>
    <div v-else-if="step===3" class="space-y-3">
      <input class="input" v-model="extra.company" placeholder="บริษัท/หน่วยงาน" />
      <textarea class="input" v-model="extra.notes" placeholder="หมายเหตุ"></textarea>
      <input type="file" class="input" @change="handleFile" />
      <div class="flex gap-2">
        <button class="btn-outline" @click="step=2">ย้อนกลับ</button>
        <button class="btn-primary" @click="step=4">ถัดไป</button>
      </div>
    </div>
    <div v-else class="space-y-3">
      <p>ตรวจสอบข้อมูลอีกครั้ง:</p>
      <ul class="text-sm">
        <li>ชื่อ: {{ firstName }} {{ lastName }}</li>
        <li>อีเมล: {{ email || '-' }}</li>
        <li>โทร: {{ phone || '-' }}</li>
        <li>บริษัท: {{ extra.company || '-' }}</li>
        <li>หมายเหตุ: {{ extra.notes || '-' }}</li>
        <li>ไฟล์: {{ file?.name || '-' }}</li>
      </ul>
      <div class="flex gap-2">
        <button class="btn-outline" @click="step=3">ย้อนกลับ</button>
        <button class="btn-primary" :disabled="submitting" @click="submitForm">
          {{ submitting ? 'กำลังส่ง...' : 'ส่งแบบฟอร์ม' }}
        </button>
      </div>
      <div v-if="errors._err" class="text-red-600">{{ errors._err[0] }}</div>
    </div>
  </div>
</template>
